import React, { useEffect, useRef } from 'react';
import { Star } from 'lucide-react';
export function Testimonials() {
  const sectionRef = useRef<HTMLElement>(null);
  const hasTracked = useRef(false);
  useEffect(() => {
    const observer = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        if (entry.isIntersecting && !hasTracked.current) {
          try {
            if (typeof window !== 'undefined' && typeof window.fbq === 'function') {
              window.fbq('trackCustom', 'ViewTestimonialsSection', {
                section: 'Social Proof'
              });
              console.log('✅ ViewTestimonialsSection event tracked');
              hasTracked.current = true;
            }
          } catch (error) {
            console.error('❌ Error tracking testimonials section:', error);
          }
        }
      });
    }, {
      threshold: 0.5
    });
    if (sectionRef.current) {
      observer.observe(sectionRef.current);
    }
    return () => observer.disconnect();
  }, []);
  return <section ref={sectionRef} className="py-12 bg-amber-50" id="testimonios" data-id="element-526">
      <div className="container mx-auto px-4 md:px-6" data-id="element-527">
        <div className="max-w-4xl mx-auto" data-id="element-528">
          <h2 className="text-2xl md:text-3xl font-bold text-amber-900 mb-8 font-serif text-center" data-id="element-529">
            Lo que dicen otras familias
          </h2>
          <div className="grid md:grid-cols-2 gap-6" data-id="element-530">
            <div className="bg-white p-6 rounded-lg border border-amber-100 shadow-sm" data-id="element-531">
              <div className="flex gap-1 mb-3" data-id="element-532">
                {[...Array(5)].map((_, i) => <Star key={i} size={16} className="text-amber-500 fill-amber-500" data-id="element-533" />)}
              </div>
              <p className="text-amber-900 mb-4" data-id="element-534">
                "Mi hijo de 5 años ahora se viste solo en 10 minutos. Antes eran
                30 minutos de pelea. Los tableros visuales fueron un cambio
                total."
              </p>
              <div className="flex items-center gap-3" data-id="element-535">
                <img src="https://randomuser.me/api/portraits/women/42.jpg" alt="Ana" className="w-10 h-10 rounded-full object-cover" data-id="element-536" />
                <div data-id="element-537">
                  <p className="font-medium text-amber-900" data-id="element-538">Ana M.</p>
                  <p className="text-sm text-amber-700" data-id="element-539">Ciudad de Guatemala</p>
                </div>
              </div>
            </div>
            <div className="bg-white p-6 rounded-lg border border-amber-100 shadow-sm" data-id="element-540">
              <div className="flex gap-1 mb-3" data-id="element-541">
                {[...Array(5)].map((_, i) => <Star key={i} size={16} className="text-amber-500 fill-amber-500" data-id="element-542" />)}
              </div>
              <p className="text-amber-900 mb-4" data-id="element-543">
                "La rutina de noche pasó de ser un caos a 20 minutos tranquilos.
                Mi hija de 3 años sabe exactamente qué sigue. ¡Sin gritos!"
              </p>
              <div className="flex items-center gap-3" data-id="element-544">
                <img src="https://randomuser.me/api/portraits/men/32.jpg" alt="Miguel" className="w-10 h-10 rounded-full object-cover" data-id="element-545" />
                <div data-id="element-546">
                  <p className="font-medium text-amber-900" data-id="element-547">Miguel R.</p>
                  <p className="text-sm text-amber-700" data-id="element-548">San José</p>
                </div>
              </div>
            </div>
            <div className="bg-white p-6 rounded-lg border border-amber-100 shadow-sm" data-id="element-549">
              <div className="flex gap-1 mb-3" data-id="element-550">
                {[...Array(5)].map((_, i) => <Star key={i} size={16} className="text-amber-500 fill-amber-500" data-id="element-551" />)}
              </div>
              <p className="text-amber-900 mb-4" data-id="element-552">
                "Los guiones de 3 pasos me salvaron. Ahora sé exactamente qué
                decir cuando mi hijo hace berrinche. Es firme pero sin gritar."
              </p>
              <div className="flex items-center gap-3" data-id="element-553">
                <img src="https://randomuser.me/api/portraits/women/67.jpg" alt="Laura" className="w-10 h-10 rounded-full object-cover" data-id="element-554" />
                <div data-id="element-555">
                  <p className="font-medium text-amber-900" data-id="element-556">Laura P.</p>
                  <p className="text-sm text-amber-700" data-id="element-557">Bogotá</p>
                </div>
              </div>
            </div>
            <div className="bg-white p-6 rounded-lg border border-amber-100 shadow-sm" data-id="element-558">
              <div className="flex gap-1 mb-3" data-id="element-559">
                {[...Array(5)].map((_, i) => <Star key={i} size={16} className="text-amber-500 fill-amber-500" data-id="element-560" />)}
              </div>
              <p className="text-amber-900 mb-4" data-id="element-561">
                "El recetario de cenas fue un regalo. Mis hijos comen sin drama
                y yo no paso horas en la cocina. ¡Gracias!"
              </p>
              <div className="flex items-center gap-3" data-id="element-562">
                <img src="https://randomuser.me/api/portraits/women/28.jpg" alt="Carmen" className="w-10 h-10 rounded-full object-cover" data-id="element-563" />
                <div data-id="element-564">
                  <p className="font-medium text-amber-900" data-id="element-565">Carmen S.</p>
                  <p className="text-sm text-amber-700" data-id="element-566">Lima</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
}